import { trpc } from '@/main'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { noop, useSuspenseQuery } from '@tanstack/react-query'
import * as v from 'valibot'
import { Test } from '@/routes/_app/-components/applicants/test'
import { TestStepPending } from '@/routes/_app/-components/shared/flow-pending'
import { flowViewTransition } from '@/lib/utils'

export const Route = createFileRoute('/_app/test/values')({
  validateSearch: v.object({
    retake: v.optional(v.boolean(), false),
    resume: v.optional(v.boolean()),
    // Carried through onboarding so the final landing can return to the visitor's intended destination.
    redirect: v.optional(v.string()),
  }),
  loaderDeps: ({ search }) => ({ retake: search.retake }),
  context: ({ deps }) => ({
    // No cache-lifetime overrides here — see test.competences.tsx for why `gcTime: 0` breaks the prefetch.
    testQuestionsQueryOptions: trpc.applicants.getQuestions.queryOptions({
      type: 'values',
      newTest: deps.retake,
    }),
  }),
  loader: ({ context }) => {
    context.queryClient.query(context.testQuestionsQueryOptions).catch(noop)
  },
  component: RouteComponent,
  pendingComponent: TestStepPending,
})

function RouteComponent() {
  const context = Route.useRouteContext()
  const { data: questionsResponse } = useSuspenseQuery(context.testQuestionsQueryOptions)
  const navigate = useNavigate()
  const { retake, redirect } = Route.useSearch()
  // Logged-out → /login is enforced centrally by the `_app` layout guard (see route-access).
  return (
    <Test
      questionsResponse={questionsResponse}
      type="values"
      // Forward only — see the note in test.competences.
      nextStep={() =>
        navigate({ to: '/test/personality', search: { redirect, retake }, viewTransition: flowViewTransition() })
      }
      previousStep={() =>
        navigate({ to: '/test/competences', search: { redirect }, viewTransition: flowViewTransition() })
      }
      newTest={retake}
    />
  )
}
